export default {
	terms: "Regulamin",
	and: "I",
	actions: {
		Submit: "Prześlij",
		BackToLogin: "Wróć do logowania",
		Register: "Zarejestruj się",
		Logout: "Wyloguj się",
		Update: "Zaktualizuj",
		Verify: "Bekreft",
		connect: "Połącz",
		Taptochange: "Stuknij, aby zmienić"
	},
	rules: {
		isRequired: "Wymagane",
		require: "{0} jest wymagane",
		valid: "{0} nie jest prawidłowym {0}",
		cannotContainBlankStrings: "{0} nie może zawierać pustych ciągów"
	},
	options: {
		gender: ["Mężczyzna", "Kobieta"]
	}
};
